import { State } from '../state';

export function getEnvironment(state: State) {
  return state.app.env;
}

export function getIsSubmitting(state: State) {
  return state.app.isSubmitting;
}
